webpackJsonp([41579278739242],{

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(66);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(50);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(424);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  var _props$opacity = props.opacity,
	      opacity = _props$opacity === undefined ? "" : _props$opacity,
	      src = props.src,
	      srcSet = props.srcSet,
	      _props$sizes = props.sizes,
	      sizes = _props$sizes === undefined ? "" : _props$sizes,
	      _props$title = props.title,
	      title = _props$title === undefined ? "" : _props$title,
	      _props$alt = props.alt,
	      alt = _props$alt === undefined ? "" : _props$alt,
	      _props$width = props.width,
	      width = _props$width === undefined ? "" : _props$width,
	      _props$height = props.height,
	      height = _props$height === undefined ? "" : _props$height,
	      _props$transitionDela = props.transitionDelay,
	      transitionDelay = _props$transitionDela === undefined ? "" : _props$transitionDela;
	
	  return "<img width=" + width + " height=" + height + " src=\"" + src + "\" srcset=\"" + srcSet + "\" alt=\"" + alt + "\" title=\"" + title + "\" sizes=\"" + sizes + "\" style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;objectPosition:center\"/>";
	};
	
	var Img = function Img(props) {
	  var opacity = props.opacity,
	      onLoad = props.onLoad,
	      _props$transitionDela2 = props.transitionDelay,
	      transitionDelay = _props$transitionDela2 === undefined ? "" : _props$transitionDela2,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["opacity", "onLoad", "transitionDelay"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: {
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      transitionDelay: transitionDelay,
	      opacity: opacity,
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }
	  }));
	};
	
	Img.propTypes = {
	  opacity: _propTypes2.default.number,
	  transitionDelay: _propTypes2.default.string,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden",
	              zIndex: 1
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement("div", {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        zIndex: 1,
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.35s"
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: ""
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func
	};
	
	exports.default = Image;

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.researchPageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(17);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(25);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _graphql = __webpack_require__(22);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _PaginateLink = __webpack_require__(100);
	
	var _PaginateLink2 = _interopRequireDefault(_PaginateLink);
	
	var _gatsbyImage = __webpack_require__(213);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _logoIcon = __webpack_require__(26);
	
	var _logoIcon2 = _interopRequireDefault(_logoIcon);
	
	var _image_thumbnail = __webpack_require__(49);
	
	var _image_thumbnail2 = _interopRequireDefault(_image_thumbnail);
	
	var _social_twitter_dark = __webpack_require__(58);
	
	var _social_twitter_dark2 = _interopRequireDefault(_social_twitter_dark);
	
	var _social_linkedin_dark = __webpack_require__(57);
	
	var _social_linkedin_dark2 = _interopRequireDefault(_social_linkedin_dark);
	
	var _image_page_sidebar = __webpack_require__(82);
	
	var _image_page_sidebar2 = _interopRequireDefault(_image_page_sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var researchTemplate = function (_Component) {
	  _inherits(researchTemplate, _Component);
	
	  function researchTemplate(props) {
	    _classCallCheck(this, researchTemplate);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.toggle = _this.toggle.bind(_this);
	    _this.state = { collapse: 0 };
	    return _this;
	  }
	
	  researchTemplate.prototype.toggle = function toggle(e) {
	    var event = e.target.dataset.event;
	    this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) });
	  };
	
	  researchTemplate.prototype.componentDidMount = function componentDidMount() {};
	
	  researchTemplate.prototype.render = function render() {
	    var collapse = this.state.collapse;
	
	    var page = this.props.data.markdownRemark;
	    var posts = this.props.data.allMarkdownRemark;
	
	    return _react2.default.createElement(
	      'div',
	      { style: this.props.transition && this.props.transition.style, className: 'research-page' },
	      _react2.default.createElement(
	        'div',
	        { className: 'navbar navbar-expand-lg navbar-dark' },
	        _react2.default.createElement('div', { className: 'navbar-blue' }),
	        _react2.default.createElement('div', { className: 'navbar-teal' })
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'page-header' },
	        _react2.default.createElement(
	          _reactstrap.Container,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: 'page-header-text', xs: { size: 12 }, md: { size: 9 } },
	              _react2.default.createElement(
	                'header',
	                { className: 'bebas' },
	                'Research'
	              ),
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Research that resonates and goes beyond insights.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'page-circular-header' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/' },
	                _react2.default.createElement('img', { src: _logoIcon2.default })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'page-content' },
	        _react2.default.createElement(
	          _reactstrap.Container,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'page-accordion' },
	            _react2.default.createElement(
	              'div',
	              { className: 'page-accordion-container', key: 0 },
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { className: 'page-link-container', md: { size: 12 } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'page-accordion-link' },
	                    _react2.default.createElement(
	                      'a',
	                      { onClick: this.toggle, 'data-event': 0, className: 'bebas' },
	                      'Research'
	                    ),
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'subheader-button', onClick: this.toggle, 'data-event': 0 },
	                      this.state.collapse === 0 ? '⊖' : '⊕'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Collapse,
	                { isOpen: collapse === 0 },
	                _react2.default.createElement(
	                  _reactstrap.Row,
	                  null,
	                  posts.edges.filter(function (post) {
	                    return post.node.frontmatter.category === 'Research';
	                  }).slice(0, 3).map(function (_ref) {
	                    var post = _ref.node,
	                        index = _ref.index;
	
	                    post = post.frontmatter;
	                    post.id = index;
	                    return _react2.default.createElement(
	                      _reactstrap.Col,
	                      { className: 'research-post authored-post', md: { size: 12 }, key: post.id },
	                      _react2.default.createElement(
	                        _reactstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactstrap.Col,
	                          { className: 'page-sidebar', xs: { size: 12 }, md: { size: 4 } },
	                          _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: post.path },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'page-sidebar-image' },
	                              post.image_featured ? _react2.default.createElement('img', { className: 'research-image', src: post.image_featured }) : _react2.default.createElement('img', { className: 'research-image', src: _image_thumbnail2.default })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.Col,
	                          { className: 'page-copy', xs: { size: 12 }, md: { size: 8 } },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'page-copy-inner' },
	                            _react2.default.createElement(
	                              'header',
	                              { className: 'bebas white-bg' },
	                              post.date
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'post-title' },
	                              _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: post.path },
	                                _react2.default.createElement(
	                                  'h1',
	                                  null,
	                                  post.title
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'height-tags' },
	                              _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { className: 'height-tag', to: '/tags/' + post.author.replace(/\s+/g, '-').toLowerCase(), key: index },
	                                post.author
	                              ),
	                              _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { className: 'height-tag', to: '/categories/' + post.category.replace(/\s+/g, '-').toLowerCase(), key: index },
	                                post.category
	                              ),
	                              post.tags.map(function (tag, index) {
	                                return _react2.default.createElement(
	                                  _gatsbyLink2.default,
	                                  { className: 'height-tag', to: '/tags/' + tag.replace('+', '').replace('+', '').replace(/\s+/g, '-').toLowerCase(), key: index },
	                                  tag
	                                );
	                              })
	                            )
	                          )
	                        )
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(
	                    _reactstrap.Col,
	                    { xs: { size: 12 }, md: { size: 8, offset: 4 }, className: 'category-nav' },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: '/categories/research', className: 'readmore-icon readmore-lg' },
	                      'View All \u203A'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'page-accordion-container', key: 1 },
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { className: 'page-link-container', md: { size: 12 } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'page-accordion-link' },
	                    _react2.default.createElement(
	                      'a',
	                      { onClick: this.toggle, 'data-event': 1, className: 'bebas' },
	                      'Height In The News'
	                    ),
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'subheader-button', onClick: this.toggle, 'data-event': 1 },
	                      this.state.collapse === 1 ? '⊖' : '⊕'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Collapse,
	                { isOpen: collapse === 1 },
	                _react2.default.createElement(
	                  _reactstrap.Row,
	                  null,
	                  posts.edges.filter(function (post) {
	                    return post.node.frontmatter.category === 'Height In The News';
	                  }).slice(0, 3).map(function (_ref2) {
	                    var post = _ref2.node,
	                        index = _ref2.index;
	
	                    post = post.frontmatter;
	                    post.id = index;
	                    return _react2.default.createElement(
	                      _reactstrap.Col,
	                      { className: 'research-post', md: { size: 12 }, key: post.id },
	                      _react2.default.createElement(
	                        _reactstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactstrap.Col,
	                          { className: 'page-sidebar', xs: { size: 12 }, md: { size: 4 } },
	                          _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: post.path },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'page-sidebar-image' },
	                              post.image_featured ? _react2.default.createElement('img', { className: 'research-image', src: post.image_featured }) : _react2.default.createElement('img', { className: 'research-image', src: _image_thumbnail2.default })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.Col,
	                          { className: 'page-copy', xs: { size: 12 }, md: { size: 8 } },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'page-copy-inner' },
	                            _react2.default.createElement(
	                              'header',
	                              { className: 'bebas white-bg' },
	                              post.date
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'post-title' },
	                              _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: post.path },
	                                _react2.default.createElement(
	                                  'h1',
	                                  null,
	                                  post.title
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'height-tags' },
	                              _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { className: 'height-tag', to: '/tags/' + post.author.replace(/\s+/g, '-').toLowerCase(), key: index },
	                                post.author
	                              ),
	                              _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { className: 'height-tag', to: '/categories/' + post.category.replace(/\s+/g, '-').toLowerCase(), key: index },
	                                post.category
	                              ),
	                              post.tags.map(function (tag, index) {
	                                return _react2.default.createElement(
	                                  _gatsbyLink2.default,
	                                  { className: 'height-tag', to: '/tags/' + tag.replace('+', '').replace('+', '').replace(/\s+/g, '-').toLowerCase(), key: index },
	                                  tag
	                                );
	                              })
	                            )
	                          )
	                        )
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(
	                    _reactstrap.Col,
	                    { xs: { size: 12 }, md: { size: 8, offset: 4 }, className: 'category-nav' },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: '/categories/height-in-the-news', className: 'readmore-icon readmore-lg' },
	                      'View All \u203A'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'page-accordion-container', key: 2 },
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { className: 'page-link-container', md: { size: 12 } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'page-accordion-link' },
	                    _react2.default.createElement(
	                      'a',
	                      { onClick: this.toggle, 'data-event': 2, className: 'bebas' },
	                      'Press Release'
	                    ),
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'subheader-button', onClick: this.toggle, 'data-event': 2 },
	                      this.state.collapse === 2 ? '⊖' : '⊕'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Collapse,
	                { isOpen: collapse === 2 },
	                _react2.default.createElement(
	                  _reactstrap.Row,
	                  null,
	                  posts.edges.filter(function (post) {
	                    return post.node.frontmatter.category === 'Press Release';
	                  }).slice(0, 3).map(function (_ref3) {
	                    var post = _ref3.node,
	                        index = _ref3.index;
	
	                    post = post.frontmatter;
	                    post.id = index;
	                    return _react2.default.createElement(
	                      _reactstrap.Col,
	                      { className: 'research-post', md: { size: 12 }, key: post.id },
	                      _react2.default.createElement(
	                        _reactstrap.Row,
	                        null,
	                        _react2.default.createElement(
	                          _reactstrap.Col,
	                          { className: 'page-sidebar', xs: { size: 12 }, md: { size: 4 } },
	                          _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: post.path },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'page-sidebar-image' },
	                              post.image_featured ? _react2.default.createElement('img', { className: 'research-image', src: post.image_featured }) : _react2.default.createElement('img', { className: 'research-image', src: _image_thumbnail2.default })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactstrap.Col,
	                          { className: 'page-copy', xs: { size: 12 }, md: { size: 8 } },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'page-copy-inner' },
	                            _react2.default.createElement(
	                              'header',
	                              { className: 'bebas white-bg' },
	                              post.date
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'post-title' },
	                              _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: post.path },
	                                _react2.default.createElement(
	                                  'h1',
	                                  null,
	                                  post.title
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'height-tags' },
	                              _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { className: 'height-tag', to: '/tags/' + post.author.replace(/\s+/g, '-').toLowerCase(), key: index },
	                                post.author
	                              ),
	                              _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { className: 'height-tag', to: '/categories/' + post.category.replace(/\s+/g, '-').toLowerCase(), key: index },
	                                post.category
	                              ),
	                              post.tags.map(function (tag, index) {
	                                return _react2.default.createElement(
	                                  _gatsbyLink2.default,
	                                  { className: 'height-tag', to: '/tags/' + tag.replace(',', '').replace('+', '').replace('+', '').replace(/\s+/g, '-').toLowerCase(), key: index },
	                                  tag
	                                );
	                              })
	                            )
	                          )
	                        )
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(
	                    _reactstrap.Col,
	                    { xs: { size: 12 }, md: { size: 8, offset: 4 }, className: 'category-nav' },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: '/categories/press-release', className: 'readmore-icon readmore-lg' },
	                      'View All \u203A'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return researchTemplate;
	}(_react.Component);
	
	exports.default = researchTemplate;
	var researchPageQuery = exports.researchPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-research-js-888360c32b5d5b4277f0.js